<template lang="pug">
.resume
    h2.resume__title {{ inOrder.project_name }}
    h3.resume__subtitle {{ $t('strings.created') }} {{ inOrder.created_at }}
    .resume__row
        vm-card
            .dates
                div
                    h3.card-title {{ $t('projects.delivery_deadline') }}
                    span.card-info {{ inOrder.created_at }}
                .card-separator
                div
                    h3.card-title {{ $t('projects.assigned_date') }}
                    span.card-info {{ inOrder.assigned_date }}
    .resume__row
        vm-card
            h3.card-title {{ $t('projects.amount') }}
            span.card-info.bold(style="color: #000000") {{ inOrder.amount | currency }}
        vm-card
            h3.card-title {{ $t('projects.deductive') }}
            span.card-info.bold(style="color: #ED1C24") {{ inOrder.deductives | currency }}
        vm-card
            h3.card-title {{ $t('projects.additive') }}
            span.card-info.bold(style="color: #3DCB6F") {{ inOrder.additives | currency }}
    .resume__row
        vm-card
            h3.card-title {{ $t('projects.total_invoiced') }}
            span.card-info.bold(style="color: #499AE0") {{ inOrder.amount_paid_invoice | currency }}
        vm-card
            h3.card-title {{ $t('projects.amount_paid') }}
            span.card-info.bold(style="color: #3DCB6F") {{ inOrder.amount_paid | currency }}
        vm-card
            h3.card-title {{ $t('projects.amount_due') }}
            span.card-info.bold(style="color: #ED1C24") {{ inOrder.amount_due | currency }}

</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('InOrders')

export default {
  name: 'Resume',
  computed: {
    ...mapGetters(['inOrder'])
  }
}
</script>

<style lang="scss">
.resume {
    margin: 1rem 0;
    &__title {
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: left;
        margin-left: 1rem;
    }

    &__subtitle {
        font-size: 16px;
        font-weight: 500;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: left;
        margin-left: 1rem;
    }

    &__row {
        display: flex;
        gap: 10px;
        text-align: center;
        margin-top: 1rem;
    }
}

.dates {
    display: flex;
    justify-content: space-around;
    align-items: center;
    &__separetor {
        color: "#BDBDBD";
    }
}
.card-title {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: center;
    margin-top: 1rem;
}
.card-info {
    font-family: Poppins;
    font-size: 32px;
    font-weight: 500;
    line-height: 48px;
    letter-spacing: 0em;
    color: #4f4f4f;
    text-align: center;
}

.card-separator {
    height: 68.21px;
    width: 1px;
    background-color: #bdbdbd;
}

.bold {
    font-weight: 700;
}
</style>
